import {UNLAYER_DEFAULT_FORM_URL} from './unlayerDefaultFormUrl';

export const unlayerDefaultFormActions = [
  {
    label: 'Default',
    method: 'POST',
    url: UNLAYER_DEFAULT_FORM_URL,
    target: '_self',
  },
];
